import type { CSSProperties } from "react";
import React, { useContext } from "react";
import cn from "classnames";

import type { ISkeletonBoxContext, ISkeletonBlockProps } from "../types";
import SkeletonBoxContext from "./SkeletonBoxContext";
import styles from "../styles/Skeleton.module.scss";

export const SkeletonBlock = ({
  width = undefined,
  height = undefined,
  className,
  isRounded,
  isInitial,
}: ISkeletonBlockProps) => {
  const context = useContext<ISkeletonBoxContext | null>(SkeletonBoxContext);
  const animStyle: CSSProperties = context?.style
    ? { width: context.style.width }
    : {};

  return (
    <div style={{ width, height }} className={className}>
      <span className={styles.skeleton} aria-busy="true">
        <span
          className={cn(styles.skeleton__bg, {
            [styles.skeleton__rounded]: isRounded,
          })}
          aria-busy="true"
        >
          <span
            className={cn(styles.skeleton__anim, {
              [styles.skeleton__anim_isInitial]: isInitial,
            })}
            style={animStyle}
            aria-busy="true"
          />
        </span>
      </span>
    </div>
  );
};

export default SkeletonBlock;
